import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Visit } from "@app/models/rest/visit";

@Injectable({
  providedIn: "root"
})
export class VisitRestService extends HateoasResourceOperation<Visit> {
  constructor() {
    super(Visit);
  }
}
